module.exports = __webpack_public_path__ + "img/redo.8177182a.svg";